var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMercator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mercator_svg__a",
    d: "M15.728.037s-3.665 3.185-6.81 9.869c1.893-4.914 1.77-8.363 1.77-8.363s-2.66 2.311-4.973 7.16C7.06 5.14 6.97 2.655 6.97 2.655S5.04 4.333 3.34 7.848c.952-2.58.888-4.372.888-4.372S2.564 4.924 1.243 7.97C-.08 11.015 0 13.223 0 13.223s1.35-1.173 2.583-3.628c-1.403 3.64-1.311 6.195-1.311 6.195s1.875-1.631 3.558-5.048c-1.963 5.005-1.836 8.533-1.836 8.533s2.6-2.26 4.895-7C5.157 19.142 5.332 24 5.332 24s4.094-3.558 7.343-11.047C15.924 5.465 15.728.037 15.728.037"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mercator_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mercator_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#515A61",
    fillRule: "nonzero",
    xlinkHref: "#mercator_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-4 0h24v24H-4z",
    mask: "url(#mercator_svg__b)"
  }))));
}

export default __webpack_public_path__ + "ondemand/static/e3056e037/icons/mercator.svg";
export { SvgMercator as ReactComponent };